/* eslint flowtype/require-valid-file-annotation:0 */

import getImportsFrom from 'app/common/lib/ReactRouter/getImports';

const getImports = getImportsFrom('app/www-unauth/routes', 'webappAssets.json');

export const LoadableDemoPage = getImports({
  loader: () => import('app/common/react/components/static/LoadableDemoPage'),
  path: 'app/common/react/components/static/LoadableDemoPage',
});
export const ReactHooksDemoPage = getImports({
  loader: () => import('app/common/react/components/static/ReactHooksDemoPage'),
  path: 'app/common/react/components/static/ReactHooksDemoPage',
});
export const BenchmarkPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "BenchmarkPage" */ 'app/common/react/components/static/BenchmarkPage'),
  name: 'BenchmarkPage',
  path: 'app/common/react/components/static/BenchmarkPage',
});
export const BusinessAccountLogin = getImports({
  loader: () =>
    import(/* webpackChunkName: "BusinessAccountLoginPageDesktop" */ 'app/www/pages/BusinessAccountLoginPage'),
  name: 'BusinessAccountLoginPageDesktop',
  path: 'app/www/pages/BusinessAccountLoginPage',
});
export const BusinessCreatePage = getImports({
  loader: () =>
    import(/* webpackChunkName: "BusinessAccountCreatePageDesktop" */ 'app/www/pages/BusinessAccountCreatePage'),
  name: 'BusinessAccountCreatePageDesktop',
  path: 'app/www/pages/BusinessAccountCreatePage',
});
export const Catalogs = getImports({
  loader: () => import(/* webpackChunkName: "CatalogsPageDesktop" */ 'app/www/pages/CatalogsPage'),
  name: 'CatalogsPageDesktop',
  path: 'app/www/pages/CatalogsPage',
});
export const Error404 = getImports({
  loader: () => import(/* webpackChunkName: "Error404PageDesktop" */ 'app/www/pages/Error404Page'),
  name: 'Error404PageDesktop',
  path: 'app/www/pages/Error404Page',
});
export const DomainFeed = getImports({
  loader: () =>
    import(/* webpackChunkName: "DomainFeedPageDesktop" */ 'app/common/react/components/MiscFeedPages/DomainFeedPage'),
  name: 'DomainFeedPageDesktop',
  path: 'app/common/react/components/MiscFeedPages/DomainFeedPage',
});

export const InvitedPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthInvitedPage" */ 'app/www-unauth/pages/UnauthInvitedPage'),
  name: 'UnauthInvitedPage',
  path: 'app/www-unauth/pages/UnauthInvitedPage',
});

// /login is broken for partners because post-login/post-signup next param not redirecting
// TODO (javery)
export const Login = getImports({
  loader: () => import(/* webpackChunkName: "UnauthLoginPage" */ 'app/www-unauth/pages/Login'),
  name: 'UnauthLoginPage',
  path: 'app/www-unauth/pages/Login',
});
export const MobileLandingPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "MobileLandingPageDesktop" */ 'app/www/pages/MobileLandingPage'),
  name: 'MobileLandingPageDesktop',
  path: 'app/www/pages/MobileLandingPage',
});
export const Search = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthSearchPageWrapper" */ 'app/common/react/components/growth/unauth/open/search/UnauthSearchPage/UnauthSearchPageWrapper'),
  name: 'UnauthSearchPageWrapper',
  path:
    'app/common/react/components/growth/unauth/open/search/UnauthSearchPage/UnauthSearchPageWrapper',
});

export const ProfilePage = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthProfilePage" */ 'app/www-unauth/pages/ProfilePage'),
  name: 'UnauthProfilePage',
  path: 'app/www-unauth/pages/ProfilePage',
});
export const ProfileDidIt = getImports({
  loader: () =>
    import(/* webpackChunkName: "DidItProfileFeedContainerDesktop" */ 'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItProfileFeedContainer'),
  name: 'DidItProfileFeedContainerDesktop',
  path:
    'app/common/react/components/do/aggregated-pins/did-it/DidItProfileFeed/DidItProfileFeedContainer',
});
export const ProfileOverview = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthUserProfileContent" */ 'app/common/react/components/growth/unauth/UnauthUserProfilePage/UnauthUserProfileContent'),
  name: 'UnauthUserProfileContent',
  path: 'app/common/react/components/growth/unauth/UnauthUserProfilePage/UnauthUserProfileContent',
});
export const FollowersPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthFollowersPage" */ 'app/www-unauth/pages/FollowersPage'),
  name: 'UnauthFollowersPage',
  path: 'app/www-unauth/pages/FollowersPage',
});
export const FollowingPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthFollowingPage" */ 'app/www-unauth/pages/FollowingPage'),
  name: 'UnauthFollowingPage',
  path: 'app/www-unauth/pages/FollowingPage',
});
export const PasswordResetPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthPasswordResetPage" */ 'app/www-unauth/pages/PasswordResetPage'),
  name: 'UnauthPasswordResetPage',
  path: 'app/www-unauth/pages/PasswordResetPage',
});
export const UnauthPasswordUserNamePage = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthPasswordUserNamePage" */ 'app/www-unauth/pages/UnauthPasswordUserNamePage'),
  name: 'UnauthPasswordUserNamePage',
  path: 'app/www-unauth/pages/UnauthPasswordUserNamePage',
});
export const PinFeedbackPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthPinFeedbackPageContainer" */ 'app/www-unauth/pages/PinFeedbackPage/PinFeedbackPageContainer'),
  name: 'UnauthPinFeedbackPageContainer',
  path: 'app/www-unauth/pages/PinFeedbackPage/PinFeedbackPageContainer',
});
export const UnauthHome = getImports({
  loader: () => import(/* webpackChunkName: "UnauthHome" */ 'app/www-unauth/pages/UnauthHome'),
  name: 'UnauthHome',
  path: 'app/www-unauth/pages/UnauthHome',
});
export const UnauthPinPageContainerNode = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthPinPageContainerNode" */ 'app/www-unauth/pages/PinPage/UnauthPinPageContainerNode.js'),
  name: 'UnauthPinPageContainerNode',
  path: 'app/www-unauth/pages/PinPage/UnauthPinPageContainerNode.js',
});
export const UnauthPinPageContainer = (seoUnauthExperiments, isBot) => {
  const group = seoUnauthExperiments.v2GetGroup(
    isBot ? 'seo_web_unauth_pin_page_node' : 'web_unauth_pin_page_node',
  );
  if (group && group.startsWith('enabled')) {
    return UnauthPinPageContainerNode;
  } else {
    return getImports({
      loader: () =>
        import(/* webpackChunkName: "UnauthPinPageContainer" */ 'app/www-unauth/pages/PinPage/UnauthPinPageContainer.js'),
      name: 'UnauthPinPageContainer',
      path: 'app/www-unauth/pages/PinPage/UnauthPinPageContainer.js',
    });
  }
};
export const UnauthBoardPageContainer = (experiments) => {
  const group = experiments.v2ActivateExperiment('unauth_lazy_import_fullpagesignup');
  if (group && group.startsWith('enabled')) {
    return getImports({
      loader: () =>
        import(/* webpackChunkName: "UnauthBoardPageLazyContainer" */ 'app/www-unauth/pages/BoardPage/UnauthBoardPageLazyContainer.js'),
      name: 'UnauthBoardPageLazyContainer',
      path: 'app/www-unauth/pages/BoardPage/UnauthBoardPageLazyContainer.js',
    });
  } else {
    return getImports({
      loader: () =>
        import(/* webpackChunkName: "UnauthBoardPagePreloadSignupContainer" */ 'app/www-unauth/pages/BoardPage/UnauthBoardPagePreloadSignupContainer.js'),
      name: 'UnauthBoardPagePreloadSignupContainer',
      path: 'app/www-unauth/pages/BoardPage/UnauthBoardPagePreloadSignupContainer.js',
    });
  }
};
export const UnauthInterestFeedPageContainer = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthInterestFeedPageContainer" */ 'app/www-unauth/pages/InterestFeedPage/UnauthInterestFeedPageContainer.js'),
  name: 'UnauthInterestFeedPageContainer',
  path: 'app/www-unauth/pages/InterestFeedPage/UnauthInterestFeedPageContainer.js',
});
export const UnauthTopicPageContainer = getImports({
  loader: () =>
    import(/* webpackChunkName: "UnauthTopicPageWrapper" */ 'app/www-unauth/pages/TopicPage/UnauthTopicPageWrapper.js'),
  name: 'UnauthTopicPageWrapper',
  path: 'app/www-unauth/pages/TopicPage/UnauthTopicPageWrapper.js',
});
export const ParentalConsentConfirmation = getImports({
  loader: () =>
    import(/* webpackChunkName: "ParentalConsentConfirmationPageDesktop" */ 'app/www/pages/ParentalConsentConfirmationPage'),
  name: 'ParentalConsentConfirmationPageDesktop',
  path: 'app/www/pages/ParentalConsentConfirmationPage',
});
export const EmailDisassociatePage = getImports({
  loader: () =>
    import(/* webpackChunkName: "EmailDisassociatePageDesktop" */ 'app/www/pages/EmailDisassociatePage'),
  name: 'EmailDisassociatePageDesktop',
  path: 'app/www/pages/EmailDisassociatePage',
});
export const EmailUnsubscribePage = getImports({
  loader: () =>
    import(/* webpackChunkName: "EmailUnsubscribePageDesktop" */ 'app/www/pages/EmailUnsubscribePage'),
  name: 'EmailUnsubscribePageDesktop',
  path: 'app/www/pages/EmailUnsubscribePage',
});
export const EmailVerificationErrorPage = getImports({
  loader: () =>
    import(/* webpackChunkName: "EmailVerificationErrorPageDesktop" */ 'app/www/pages/EmailVerificationErrorPage'),
  name: 'EmailVerificationErrorPageDesktop',
  path: 'app/www/pages/EmailVerificationErrorPage',
});
